// import logoPlaceholder from '../img/series2022/placeholders/logoPlaceholder.jpg';
// import posterPlaceholder from '../img/series2022/placeholders/dragonsPoster.jpg';
// import heroPlaceholder from '../img/series2022/placeholders/heroPlaceholder.jpg';
import itemPlaceholder from '../img/series2022/placeholders/itemPlaceholder.jpg';
import galleryPlaceholder from '../img/series2022/placeholders/galleryPlaceholder.jpg';
import galleryStillPlaceholder from '../img/series2022/placeholders/galleryStillPlaceholder.jpg';

// Streaming Logos
import Netflix from '../img/netflix.svg';
import Hulu from '../img/hulu.svg';
import Peacock from '../img/peacock.svg';
import AppleTV from '../img/appleTV.svg';

// JURASSIC WORLD: CAMP CRETACEOUS
import JW_Logo from '../img/series2022/JurassicWorld/logo.png';
import JW_Poster from '../img/series2022/JurassicWorld/poster.jpg';
import JW_Hero from '../img/series2022/JurassicWorld/inner/hero.jpg';
import JW_Item1 from '../img/series2022/JurassicWorld/inner/items/1.jpg';
import JW_Item2 from '../img/series2022/JurassicWorld/inner/items/2.jpg';
import JW_Item3 from '../img/series2022/JurassicWorld/inner/items/3.jpg';
import JW_Gallery from '../img/series2022/JurassicWorld/inner/gallery/poster.jpg';
import JW_Gallery_1 from '../img/series2022/JurassicWorld/inner/gallery/stills/1.jpg';
import JW_Gallery_2 from '../img/series2022/JurassicWorld/inner/gallery/stills/2.jpg';
import JW_Gallery_3 from '../img/series2022/JurassicWorld/inner/gallery/stills/3.jpg';
import JW_Gallery_4 from '../img/series2022/JurassicWorld/inner/gallery/stills/4.jpg';
import JW_Gallery_5 from '../img/series2022/JurassicWorld/inner/gallery/stills/5.jpg';
import JW_Gallery_6 from '../img/series2022/JurassicWorld/inner/gallery/stills/6.jpg';
import JW_Consideration from '../img/series2022/JurassicWorld/inner/consideration/poster.jpg';
import JW_Consideration_1 from '../img/series2022/JurassicWorld/inner/consideration/stills/1.jpg';
import JW_Consideration_2 from '../img/series2022/JurassicWorld/inner/consideration/stills/2.jpg';
import JW_Consideration_3 from '../img/series2022/JurassicWorld/inner/consideration/stills/3.jpg';
import JW_Consideration_4 from '../img/series2022/JurassicWorld/inner/consideration/stills/4.jpg';
import JW_Consideration_5 from '../img/series2022/JurassicWorld/inner/consideration/stills/5.jpg';
import JW_Consideration_6 from '../img/series2022/JurassicWorld/inner/consideration/stills/6.jpg';
import JW_Consideration_7 from '../img/series2022/JurassicWorld/inner/consideration/stills/7.jpg';
import JW_Consideration_8 from '../img/series2022/JurassicWorld/inner/consideration/stills/8.jpg';

// TROLL HUNTERS
import TH_Logo from '../img/series2022/TrollHunters/logo.png';
import TH_Poster from '../img/series2022/TrollHunters/poster.jpg';
import TH_Hero from '../img/series2022/TrollHunters/inner/hero.jpg';
import TH_Item1 from '../img/series2022/TrollHunters/inner/items/1.jpg';
import TH_Item2 from '../img/series2022/TrollHunters/inner/items/2.jpg';
import TH_Item3 from '../img/series2022/TrollHunters/inner/items/3.jpg';
import TH_Gallery from '../img/series2022/TrollHunters/inner/gallery/poster.jpg';
import TH_Gallery_1 from "../img/series2022/TrollHunters/inner/gallery/stills/1.jpg";
import TH_Gallery_2 from "../img/series2022/TrollHunters/inner/gallery/stills/2.jpg";
import TH_Gallery_3 from "../img/series2022/TrollHunters/inner/gallery/stills/3.jpg";
import TH_Gallery_4 from "../img/series2022/TrollHunters/inner/gallery/stills/4.jpg";
import TH_Gallery_5 from "../img/series2022/TrollHunters/inner/gallery/stills/5.jpg";
import TH_Gallery_6 from "../img/series2022/TrollHunters/inner/gallery/stills/6.jpg";
import TH_Consideration from '../img/series2022/TrollHunters/inner/consideration/poster.jpg';
import TH_Consideration_1 from '../img/series2022/TrollHunters/inner/consideration/stills/1.jpg';
import TH_Consideration_2 from '../img/series2022/TrollHunters/inner/consideration/stills/2.jpg';
import TH_Consideration_3 from '../img/series2022/TrollHunters/inner/consideration/stills/3.jpg';
import TH_Consideration_4 from '../img/series2022/TrollHunters/inner/consideration/stills/4.jpg';
import TH_Consideration_5 from '../img/series2022/TrollHunters/inner/consideration/stills/5.jpg';
import TH_Consideration_6 from '../img/series2022/TrollHunters/inner/consideration/stills/6.jpg';
import TH_Consideration_7 from '../img/series2022/TrollHunters/inner/consideration/stills/7.jpg';
import TH_Consideration_8 from '../img/series2022/TrollHunters/inner/consideration/stills/8.jpg';
import TH_Consideration_9 from '../img/series2022/TrollHunters/inner/consideration/stills/9.jpg';
import TH_Consideration_10 from '../img/series2022/TrollHunters/inner/consideration/stills/10.jpg';

// GABBYS DOLLHOUSE
import GD_Logo from '../img/series2022/GabbysDollhouse/logo.png';
import GD_Poster from '../img/series2022/GabbysDollhouse/poster.jpg';
import GD_Hero from '../img/series2022/GabbysDollhouse/inner/hero.jpg';
import GD_Item1 from '../img/series2022/GabbysDollhouse/inner/items/1.jpg';
import GD_Item2 from '../img/series2022/GabbysDollhouse/inner/items/2.jpg';
import GD_Item3 from '../img/series2022/GabbysDollhouse/inner/items/3.jpg';
import GD_Gallery from '../img/series2022/GabbysDollhouse/inner/gallery/poster.jpg';
import GD_Gallery_1 from "../img/series2022/GabbysDollhouse/inner/gallery/stills/1.jpg";
import GD_Gallery_2 from "../img/series2022/GabbysDollhouse/inner/gallery/stills/2.jpg";
import GD_Gallery_3 from "../img/series2022/GabbysDollhouse/inner/gallery/stills/3.jpg";
import GD_Gallery_4 from "../img/series2022/GabbysDollhouse/inner/gallery/stills/4.jpg";
import GD_Gallery_5 from "../img/series2022/GabbysDollhouse/inner/gallery/stills/5.jpg";

// FAST & FURIOUS: SPY RACERS
import FF_Logo from '../img/series2022/FastFurious/logo.png';
import FF_Poster from '../img/series2022/FastFurious/poster.jpg';
import FF_Hero from '../img/series2022/FastFurious/inner/hero.jpg';
import FF_Item1 from '../img/series2022/FastFurious/inner/items/1.jpg';
import FF_Item2 from '../img/series2022/FastFurious/inner/items/2.jpg';
import FF_Item3 from '../img/series2022/FastFurious/inner/items/3.jpg';
import FF_Gallery from '../img/series2022/FastFurious/inner/gallery/poster.jpg';
import FF_Gallery_1 from "../img/series2022/FastFurious/inner/gallery/stills/1.jpg";
import FF_Gallery_2 from "../img/series2022/FastFurious/inner/gallery/stills/2.jpg";
import FF_Gallery_3 from "../img/series2022/FastFurious/inner/gallery/stills/3.jpg";
import FF_Gallery_4 from "../img/series2022/FastFurious/inner/gallery/stills/4.jpg";
import FF_Gallery_5 from "../img/series2022/FastFurious/inner/gallery/stills/5.jpg";
import FF_Gallery_6 from "../img/series2022/FastFurious/inner/gallery/stills/6.jpg";
import FF_Gallery_7 from "../img/series2022/FastFurious/inner/gallery/stills/7.jpg";
import FF_Gallery_8 from "../img/series2022/FastFurious/inner/gallery/stills/8.jpg";
import FF_Gallery_9 from "../img/series2022/FastFurious/inner/gallery/stills/9.jpg";
import FF_Gallery_10 from "../img/series2022/FastFurious/inner/gallery/stills/10.jpg";
import FF_Gallery_11 from "../img/series2022/FastFurious/inner/gallery/stills/11.jpg";
import FF_Gallery_12 from "../img/series2022/FastFurious/inner/gallery/stills/12.jpg";
import FF_Consideration from '../img/series2022/FastFurious/inner/consideration/poster.jpg';
import FF_Consideration_1 from '../img/series2022/FastFurious/inner/consideration/stills/1.jpg';
import FF_Consideration_2 from '../img/series2022/FastFurious/inner/consideration/stills/2.jpg';
import FF_Consideration_3 from '../img/series2022/FastFurious/inner/consideration/stills/3.jpg';
import FF_Consideration_4 from '../img/series2022/FastFurious/inner/consideration/stills/4.jpg';
import FF_Consideration_5 from '../img/series2022/FastFurious/inner/consideration/stills/5.jpg';
import FF_Consideration_6 from '../img/series2022/FastFurious/inner/consideration/stills/6.jpg';
import FF_Consideration_7 from '../img/series2022/FastFurious/inner/consideration/stills/7.jpg';
import FF_Consideration_8 from '../img/series2022/FastFurious/inner/consideration/stills/8.jpg';
import FF_Consideration_9 from '../img/series2022/FastFurious/inner/consideration/stills/9.jpg';
import FF_Consideration_10 from '../img/series2022/FastFurious/inner/consideration/stills/10.jpg';

// CROODS
import CDS_Logo from '../img/series2022/Croods/logo.png';
import CDS_Poster from '../img/series2022/Croods/poster.jpg';
import CDS_Hero from '../img/series2022/Croods/inner/hero.jpg';
import CDS_Item1 from '../img/series2022/Croods/inner/items/1.jpg';
import CDS_Item2 from '../img/series2022/Croods/inner/items/2.jpg';
import CDS_Item3 from '../img/series2022/Croods/inner/items/3.jpg';
import CDS_Gallery from '../img/series2022/Croods/inner/gallery/poster.jpg';
import CDS_Gallery_1 from "../img/series2022/Croods/inner/gallery/stills/1.jpg";
import CDS_Gallery_2 from "../img/series2022/Croods/inner/gallery/stills/2.jpg";
import CDS_Gallery_3 from "../img/series2022/Croods/inner/gallery/stills/3.jpg";
import CDS_Gallery_4 from "../img/series2022/Croods/inner/gallery/stills/4.jpg";
import CDS_Gallery_5 from "../img/series2022/Croods/inner/gallery/stills/5.jpg";
import CDS_Gallery_6 from "../img/series2022/Croods/inner/gallery/stills/6.jpg";
import CDS_Gallery_7 from "../img/series2022/Croods/inner/gallery/stills/7.jpg";
import CDS_Gallery_8 from "../img/series2022/Croods/inner/gallery/stills/8.jpg";

// GO DOG GO
import GDG_Logo from '../img/series2022/GoDogGo/logo.png';
import GDG_Poster from '../img/series2022/GoDogGo/poster.jpg';
import GDG_Hero from '../img/series2022/GoDogGo/inner/hero.jpg';
import GDG_Item1 from '../img/series2022/GoDogGo/inner/items/1.jpg';
import GDG_Item2 from '../img/series2022/GoDogGo/inner/items/2.jpg';
import GDG_Item3 from '../img/series2022/GoDogGo/inner/items/3.jpg';
import GDG_Gallery from '../img/series2022/GoDogGo/inner/gallery/poster.jpg';
import GDG_Gallery_1 from "../img/series2022/GoDogGo/inner/gallery/stills/1.jpg";
import GDG_Gallery_2 from "../img/series2022/GoDogGo/inner/gallery/stills/2.jpg";
import GDG_Gallery_3 from "../img/series2022/GoDogGo/inner/gallery/stills/3.jpg";

// MADAGASCAR: A LITTLE WILD
import MAD_Logo from '../img/series2022/Madagascar/logo.png';
import MAD_Poster from '../img/series2022/Madagascar/poster.jpg';
import MAD_Hero from '../img/series2022/Madagascar/inner/hero.jpg';
import MAD_Item1 from '../img/series2022/Madagascar/inner/items/1.jpg';
import MAD_Item2 from '../img/series2022/Madagascar/inner/items/2.jpg';
import MAD_Item3 from '../img/series2022/Madagascar/inner/items/3.jpg';
import MAD_Bonus from '../img/series2022/Madagascar/inner/bonus.jpg';
import MAD_Gallery from '../img/series2022/Madagascar/inner/gallery/poster.jpg';
import MAD_Gallery_1 from '../img/series2022/Madagascar/inner/gallery/stills/1.jpg';
import MAD_Gallery_2 from '../img/series2022/Madagascar/inner/gallery/stills/2.jpg';
import MAD_Gallery_3 from '../img/series2022/Madagascar/inner/gallery/stills/3.jpg';
import MAD_Gallery_4 from '../img/series2022/Madagascar/inner/gallery/stills/4.jpg';
import MAD_Gallery_5 from '../img/series2022/Madagascar/inner/gallery/stills/5.jpg';

// ARCHIBALD'S NEXT BIG THING
import NBT_Logo from '../img/series2022/Archibalds/logo.png';
import NBT_Poster from '../img/series2022/Archibalds/poster.jpg';
import NBT_Hero from '../img/series2022/Archibalds/inner/hero.jpg';
import NBT_Item1 from '../img/series2022/Archibalds/inner/items/1.jpg';
import NBT_Item2 from '../img/series2022/Archibalds/inner/items/2.jpg';
import NBT_Item3 from '../img/series2022/Archibalds/inner/items/3.jpg';
import NBT_Gallery from '../img/series2022/Archibalds/inner/gallery/poster.jpg';
import NBT_Gallery_1 from '../img/series2022/Archibalds/inner/gallery/stills/1.jpg';
import NBT_Gallery_2 from '../img/series2022/Archibalds/inner/gallery/stills/2.jpg';
import NBT_Gallery_3 from '../img/series2022/Archibalds/inner/gallery/stills/3.jpg';
import NBT_Gallery_4 from '../img/series2022/Archibalds/inner/gallery/stills/4.jpg';
import NBT_Gallery_5 from '../img/series2022/Archibalds/inner/gallery/stills/5.jpg';
import NBT_Gallery_6 from '../img/series2022/Archibalds/inner/gallery/stills/6.jpg';

// THE MIGHTY ONES
import TMO_Logo from '../img/series2022/MightyOnes/logo.png';
import TMO_Poster from '../img/series2022/MightyOnes/poster.jpg';
import TMO_Hero from '../img/series2022/MightyOnes/inner/hero.jpg';
import TMO_Item1 from '../img/series2022/MightyOnes/inner/items/1.jpg';
import TMO_Item2 from '../img/series2022/MightyOnes/inner/items/2.jpg';
import TMO_Item3 from '../img/series2022/MightyOnes/inner/items/3.jpg';
import TMO_Consideration from '../img/series2022/MightyOnes/inner/consideration/poster.jpg';
import TMO_Consideration_1 from '../img/series2022/MightyOnes/inner/consideration/stills/1.jpg';
import TMO_Consideration_2 from '../img/series2022/MightyOnes/inner/consideration/stills/2.jpg';
import TMO_Consideration_3 from '../img/series2022/MightyOnes/inner/consideration/stills/3.jpg';
import TMO_Consideration_4 from '../img/series2022/MightyOnes/inner/consideration/stills/4.jpg';
import TMO_Consideration_5 from '../img/series2022/MightyOnes/inner/consideration/stills/5.jpg';
import TMO_Consideration_6 from '../img/series2022/MightyOnes/inner/consideration/stills/6.jpg';
import TMO_Consideration_7 from '../img/series2022/MightyOnes/inner/consideration/stills/7.jpg';
import TMO_Consideration_8 from '../img/series2022/MightyOnes/inner/consideration/stills/8.jpg';
import TMO_Consideration_9 from '../img/series2022/MightyOnes/inner/consideration/stills/9.jpg';
import TMO_Gallery from '../img/series2022/MightyOnes/inner/gallery/poster.jpg';
import TMO_Gallery_1 from '../img/series2022/MightyOnes/inner/gallery/stills/1.jpg';
import TMO_Gallery_2 from '../img/series2022/MightyOnes/inner/gallery/stills/2.jpg';
import TMO_Gallery_3 from '../img/series2022/MightyOnes/inner/gallery/stills/3.jpg';
import TMO_Gallery_4 from '../img/series2022/MightyOnes/inner/gallery/stills/4.jpg';
import TMO_Gallery_5 from '../img/series2022/MightyOnes/inner/gallery/stills/5.jpg';

// DOUG UNPLUGS
import DU_Logo from '../img/series2022/DougUnplugs/logo.png';
import DU_Poster from '../img/series2022/DougUnplugs/poster.jpg';
import DU_Hero from '../img/series2022/DougUnplugs/inner/hero.jpg';
import DU_Item1 from '../img/series2022/DougUnplugs/inner/items/1.jpg';
import DU_Item2 from '../img/series2022/DougUnplugs/inner/items/2.jpg';
import DU_Item3 from '../img/series2022/DougUnplugs/inner/items/3.jpg';
import DU_Gallery from '../img/series2022/DougUnplugs/inner/gallery/poster.jpg';
import DU_Gallery_1 from '../img/series2022/DougUnplugs/inner/gallery/stills/1.jpg';
import DU_Gallery_2 from '../img/series2022/DougUnplugs/inner/gallery/stills/2.jpg';
import DU_Gallery_3 from '../img/series2022/DougUnplugs/inner/gallery/stills/3.jpg';
import DU_Gallery_4 from '../img/series2022/DougUnplugs/inner/gallery/stills/4.jpg';
import DU_Gallery_5 from '../img/series2022/DougUnplugs/inner/gallery/stills/5.jpg';
import DU_Gallery_6 from '../img/series2022/DougUnplugs/inner/gallery/stills/6.jpg';
import DU_Gallery_7 from '../img/series2022/DougUnplugs/inner/gallery/stills/7.jpg';

// DRAGONS RESCUE RIDERS
import DRR_Logo from '../img/series2022/RescueRiders/logo.png';
import DRR_Logo2 from '../img/series2022/RescueRiders/logo2.png';
import DRR_Poster from '../img/series2022/RescueRiders/poster.jpg';
import DRR_Hero from '../img/series2022/RescueRiders/inner/hero.jpg';
import DRR_Item1 from '../img/series2022/RescueRiders/inner/items/1.jpg';
import DRR_Item2 from '../img/series2022/RescueRiders/inner/items/2.jpg';
import DRR_Gallery from '../img/series2022/RescueRiders/inner/gallery/poster.jpg';
import DRR_Gallery_1 from '../img/series2022/RescueRiders/inner/gallery/stills/1.jpg';
import DRR_Gallery_2 from '../img/series2022/RescueRiders/inner/gallery/stills/2.jpg';
import DRR_Gallery_3 from '../img/series2022/RescueRiders/inner/gallery/stills/3.jpg';
import DRR_Gallery_4 from '../img/series2022/RescueRiders/inner/gallery/stills/4.jpg';
import DRR_Gallery_5 from '../img/series2022/RescueRiders/inner/gallery/stills/5.jpg';

// TROLLS: TROLLSTOPIA
import TROLL_Logo from '../img/series2022/Trolls/logo.png';
import TROLL_Poster from '../img/series2022/Trolls/poster.jpg';
import TROLL_Hero from '../img/series2022/Trolls/inner/hero.jpg';
import TROLL_Item1 from '../img/series2022/Trolls/inner/items/1.jpg';
import TROLL_Item2 from '../img/series2022/Trolls/inner/items/2.jpg';
import TROLL_Item3 from '../img/series2022/Trolls/inner/items/3.jpg';
import TROLL_Gallery from '../img/series2022/Trolls/inner/gallery/poster.jpg';
import TROLL_Gallery_1 from '../img/series2022/Trolls/inner/gallery/stills/1.jpg';
import TROLL_Gallery_2 from '../img/series2022/Trolls/inner/gallery/stills/2.jpg';
import TROLL_Gallery_3 from '../img/series2022/Trolls/inner/gallery/stills/3.jpg';
import TROLL_Gallery_4 from '../img/series2022/Trolls/inner/gallery/stills/4.jpg';
import TROLL_Gallery_5 from '../img/series2022/Trolls/inner/gallery/stills/5.jpg';

// RHYME TIME TOWN (SERIES)
import RTT_Logo from '../img/series2022/RhymeTimeTown/logo.png';
import RTT_Poster from '../img/series2022/RhymeTimeTown/poster.jpg';
import RTT_Hero from '../img/series2022/RhymeTimeTown/inner/hero.jpg';
import RTT_Item1 from '../img/series2022/RhymeTimeTown/inner/items/1.jpg';

// DRAGONS: NINE REALMS
import DNR_Logo from '../img/series2022/NineRealms/logo.png';
import DNR_Poster from '../img/series2022/NineRealms/poster.jpg';
import DNR_Hero from '../img/series2022/NineRealms/inner/hero.jpg';
import DNR_Item1 from '../img/series2022/NineRealms/inner/items/1.jpg';
import DNR_Item2 from '../img/series2022/NineRealms/inner/items/2.jpg';
import DNR_Gallery from '../img/series2022/NineRealms/inner/gallery/poster.jpg';
import DNR_Gallery_1 from '../img/series2022/NineRealms/inner/gallery/stills/1.jpg';
import DNR_Gallery_2 from '../img/series2022/NineRealms/inner/gallery/stills/2.jpg';
import DNR_Gallery_3 from '../img/series2022/NineRealms/inner/gallery/stills/3.jpg';
import DNR_Gallery_4 from '../img/series2022/NineRealms/inner/gallery/stills/4.jpg';
import DNR_Gallery_5 from '../img/series2022/NineRealms/inner/gallery/stills/5.jpg';
import DNR_Gallery_6 from '../img/series2022/NineRealms/inner/gallery/stills/6.jpg';
import DNR_Gallery_7 from '../img/series2022/NineRealms/inner/gallery/stills/7.jpg';
import DNR_Gallery_8 from '../img/series2022/NineRealms/inner/gallery/stills/8.jpg';
import DNR_Gallery_9 from '../img/series2022/NineRealms/inner/gallery/stills/9.jpg';
import DNR_Gallery_10 from '../img/series2022/NineRealms/inner/gallery/stills/10.jpg';
import DNR_Gallery_11 from '../img/series2022/NineRealms/inner/gallery/stills/11.jpg';
import DNR_Gallery_12 from '../img/series2022/NineRealms/inner/gallery/stills/12.jpg';
import DNR_Gallery_13 from '../img/series2022/NineRealms/inner/gallery/stills/13.jpg';
import DNR_Gallery_14 from '../img/series2022/NineRealms/inner/gallery/stills/14.jpg';
import DNR_Gallery_15 from '../img/series2022/NineRealms/inner/gallery/stills/15.jpg';
import DNR_Gallery_16 from '../img/series2022/NineRealms/inner/gallery/stills/16.jpg';
import DNR_Gallery_17 from '../img/series2022/NineRealms/inner/gallery/stills/17.jpg';

export const images = [
	itemPlaceholder,
	galleryPlaceholder,
	galleryStillPlaceholder,
	Netflix,
	Hulu,
	Peacock,
	AppleTV,
	JW_Logo,
	JW_Poster,
	JW_Hero,
	JW_Item1,
	JW_Item2,
	JW_Item3,
	JW_Gallery,
	JW_Gallery_1,
	JW_Gallery_2,
	JW_Gallery_3,
	JW_Gallery_4,
	JW_Gallery_5,
	JW_Gallery_6,
	JW_Consideration,
	JW_Consideration_1,
	JW_Consideration_2,
	JW_Consideration_3,
	JW_Consideration_4,
	JW_Consideration_5,
	JW_Consideration_6,
	JW_Consideration_7,
	JW_Consideration_8,
	TH_Logo,
	TH_Poster,
	TH_Hero,
	TH_Item1,
	TH_Item2,
	TH_Item3,
	TH_Gallery,
	TH_Gallery_1,
	TH_Gallery_2,
	TH_Gallery_3,
	TH_Gallery_4,
	TH_Gallery_5,
	TH_Gallery_6,
	TH_Consideration,
	TH_Consideration_1,
	TH_Consideration_2,
	TH_Consideration_3,
	TH_Consideration_4,
	TH_Consideration_5,
	TH_Consideration_6,
	TH_Consideration_7,
	TH_Consideration_8,
	TH_Consideration_9,
	TH_Consideration_10,
	GD_Logo,
	GD_Poster,
	GD_Hero,
	GD_Item1,
	GD_Item2,
	GD_Item3,
	GD_Gallery,
	GD_Gallery_1,
	GD_Gallery_2,
	GD_Gallery_3,
	GD_Gallery_4,
	GD_Gallery_5,
	FF_Logo,
	FF_Poster,
	FF_Hero,
	FF_Item1,
	FF_Item2,
	FF_Item3,
	FF_Gallery,
	FF_Gallery_1,
	FF_Gallery_2,
	FF_Gallery_3,
	FF_Gallery_4,
	FF_Gallery_5,
	FF_Gallery_6,
	FF_Gallery_7,
	FF_Gallery_8,
	FF_Gallery_9,
	FF_Gallery_10,
	FF_Gallery_11,
	FF_Gallery_12,
	FF_Consideration,
	FF_Consideration_1,
	FF_Consideration_2,
	FF_Consideration_3,
	FF_Consideration_4,
	FF_Consideration_5,
	FF_Consideration_6,
	FF_Consideration_7,
	FF_Consideration_8,
	FF_Consideration_9,
	FF_Consideration_10,
	CDS_Logo,
	CDS_Poster,
	CDS_Hero,
	CDS_Item1,
	CDS_Item2,
	CDS_Item3,
	CDS_Gallery,
	CDS_Gallery_1,
	CDS_Gallery_2,
	CDS_Gallery_3,
	CDS_Gallery_4,
	CDS_Gallery_5,
	CDS_Gallery_6,
	CDS_Gallery_7,
	CDS_Gallery_8,
	GDG_Logo,
	GDG_Poster,
	GDG_Hero,
	GDG_Item1,
	GDG_Item2,
	GDG_Item3,
	GDG_Gallery,
	GDG_Gallery_1,
	GDG_Gallery_2,
	GDG_Gallery_3,
	MAD_Logo,
	MAD_Poster,
	MAD_Hero,
	MAD_Item1,
	MAD_Item2,
	MAD_Item3,
	MAD_Bonus,
	MAD_Gallery,
	MAD_Gallery_1,
	MAD_Gallery_2,
	MAD_Gallery_3,
	MAD_Gallery_4,
	MAD_Gallery_5,
	NBT_Logo,
	NBT_Poster,
	NBT_Hero,
	NBT_Item1,
	NBT_Item2,
	NBT_Item3,
	NBT_Gallery,
	NBT_Gallery_1,
	NBT_Gallery_2,
	NBT_Gallery_3,
	NBT_Gallery_4,
	NBT_Gallery_5,
	NBT_Gallery_6,
	TMO_Logo,
	TMO_Poster,
	TMO_Hero,
	TMO_Item1,
	TMO_Item2,
	TMO_Item3,
	TMO_Consideration,
	TMO_Consideration_1,
	TMO_Consideration_2,
	TMO_Consideration_3,
	TMO_Consideration_4,
	TMO_Consideration_5,
	TMO_Consideration_6,
	TMO_Consideration_7,
	TMO_Consideration_8,
	TMO_Consideration_9,
	TMO_Gallery,
	TMO_Gallery_1,
	TMO_Gallery_2,
	TMO_Gallery_3,
	TMO_Gallery_4,
	TMO_Gallery_5,
	DU_Logo,
	DU_Poster,
	DU_Hero,
	DU_Item1,
	DU_Item2,
	DU_Item3,
	DU_Gallery,
	DU_Gallery_1,
	DU_Gallery_2,
	DU_Gallery_3,
	DU_Gallery_4,
	DU_Gallery_5,
	DU_Gallery_6,
	DU_Gallery_7,
	DRR_Logo,
	DRR_Logo2,
	DRR_Poster,
	DRR_Hero,
	DRR_Item1,
	DRR_Item2,
	DRR_Gallery,
	DRR_Gallery_1,
	DRR_Gallery_2,
	DRR_Gallery_3,
	DRR_Gallery_4,
	DRR_Gallery_5,
	TROLL_Logo,
	TROLL_Poster,
	TROLL_Hero ,
	TROLL_Item1,
	TROLL_Item2,
	TROLL_Item3,
	TROLL_Gallery,
	TROLL_Gallery_1,
	TROLL_Gallery_2,
	TROLL_Gallery_3,
	TROLL_Gallery_4,
	TROLL_Gallery_5,
	RTT_Logo,
	RTT_Poster,
	RTT_Hero,
	RTT_Item1,
	DNR_Logo,
	DNR_Poster,
	DNR_Hero,
	DNR_Gallery,
	DNR_Gallery_1,
	DNR_Gallery_2,
	DNR_Gallery_3,
	DNR_Gallery_4,
	DNR_Gallery_5,
	DNR_Gallery_6,
	DNR_Gallery_7,
	DNR_Gallery_8,
	DNR_Gallery_9,
	DNR_Gallery_10,
	DNR_Gallery_11,
	DNR_Gallery_12,
	DNR_Gallery_13,
	DNR_Gallery_14,
	DNR_Gallery_15,
	DNR_Gallery_16,
	DNR_Gallery_17
]

const currentYear = new Date().getFullYear();

export const projects = [
	// JURASSIC WORLD: CAMP CRETACEOUS
	{
		"id": 0,
		"layout": "first",
		"name": "Jurassic World: Camp Cretaceous",
		"slug": "jurassic-world-camp-cretaceous",
		"logo": JW_Logo,
		"poster": JW_Poster,
		"inner": {
			"hero": JW_Hero,
			"copyright": "Jurassic World Franchise © "+currentYear+" Universal City Studios LLC and Amblin Entertainment INC. Series © "+currentYear+" Dreamworks Animation LLC. All Rights Reserved.",
			"description": "Six teenagers chosen for a once-in-a-lifetime experience at Camp Cretaceous, a new adventure camp on the opposite side of Isla Nublar, must work together to survive when dinosaurs wreak havoc across the island.",
			"streaming": [
				{
					"platform": "Netflix",
					"logo": Netflix,
					"link": "https://www.netflix.com/title/81009646"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/h_0vTlkLGOc?autoplay=1",
					"poster": JW_Item1,
					"title": "Series Trailer",
					"description": "The campers uncover more details of Dr. Wu’s secret research and must quickly take their fate into their own hands with a dangerous plan to leave Isla Nublar behind for good."
				},
				{
					"video": "https://www.youtube.com/embed/nOcKPLh7JeI?autoplay=1",
					"poster": JW_Item2,
					"title": "Scorpios Rex",
					"description": "As a storm descends upon the island, the kids find themselves in grave danger as the Scorpius Rex appears at their camp."
				},
				{
					"video": "https://www.youtube.com/embed/CCDX5hui1M8?autoplay=1",
					"poster": JW_Item3,
					"title": "Returning to Jurassic Park",
					"description": "The campers stumble upon the original Jurassic Park Vistors Center."
				},
			],
			"consideration": {
				"poster": JW_Consideration,
				"title": "Production Design by John-Paul\nBalmet, Christophe\nVacher, Chris\nSears, Sherwin\nAbesamis and Peter\nKim",
				"description": "John-Paul\nBalmet, Christophe\nVacher, Chris\nSears, Sherwin\nAbesamis and Peter\nKim created a stunning production design.",
				"btnText": "View Now",
				"images": [
					JW_Consideration_1,
					JW_Consideration_2,
					JW_Consideration_3,
					JW_Consideration_4,
					JW_Consideration_5,
					JW_Consideration_6,
					JW_Consideration_7,
					JW_Consideration_8
				]
			},
			"gallery": {
				"poster": JW_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					JW_Gallery_1,
					JW_Gallery_2,
					JW_Gallery_3,
					JW_Gallery_4,
					JW_Gallery_5,
					JW_Gallery_6
				]
			}
		}
	},
	// TROLLHUNTERS: RISE OF THE TITANS
	{
		"id": 1,
		"layout": "first",
		"name": "TrollHunters: Rise of the Titans",
		"slug": "trollhunters-rise-of-the-titans",
		"logo": TH_Logo,
		"poster": TH_Poster,
		"inner": {
			"hero": TH_Hero,
			"copyright": "Dreamworks Tales of Arcadia © "+currentYear+" Dreamworks Animation LLC. All Rights Reserved.",
			"description": "On the surface, Arcadia appears to be a slice of timeless Americana, but it is no ordinary town. It lies at the center of magical and mystical lines that make it a nexus for many battles among otherworldly creatures including trolls, aliens and wizards. Following the events of the Tales of Arcadia trilogy, the heroes of Arcadia must band together to protect humanity from the evil Arcane Order, who wield their dark and uncontrollable magic to summon ancient titans that threaten to destroy the world.",
			"streaming": [
				{
					"platform": "Netflix",
					"logo": Netflix,
					"link": "https://www.netflix.com/title/81010139"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/3TWN0MWlM7Y?autoplay=1",
					"poster": TH_Item1,
					"title": "Series Trailer",
					"description": "In an epic conclusion to the Tales of Arcadia saga, our heroes must unite their worlds in order to save the universe."
				},
				{
					"video": "https://www.youtube.com/embed/G1ahEdO-xy0?autoplay=1",
					"poster": TH_Item2,
					"title": "Rise of the Titans Creative Team",
					"description": "Hear from the Creative Team behind Trollhunters: Rise of the Titans including creator Guillermo del Toro, Chad Hammes, Johane Matte, Francisco Ruiz and Andrew Schmidt."
				},
				{
					"video": "https://www.youtube.com/embed/6Ggg1P5ppvk?autoplay=1",
					"poster": TH_Item3,
					"title": "Behind The Animation",
					"description": "Director Francisco Ruiz breaks down the animation secrets of the Titans and their epic fighting in Trollhunters: Rise of the Titans."
				}
			],
			"consideration": {
				"poster": TH_Consideration,
				"title": "Production Design by Alfonso\nBlaas, Yingjue\nLinda\nChen and Francisco\nRuiz",
				"description": "Alfonso\nBlaas, Yingjue\nLinda\nChen and Francisco\nRuiz created a stunning production design.",
				"btnText": "View Now",
				"images": [
					TH_Consideration_1,
					TH_Consideration_2,
					TH_Consideration_3,
					TH_Consideration_4,
					TH_Consideration_5,
					TH_Consideration_6,
					TH_Consideration_7,
					TH_Consideration_8,
					TH_Consideration_9,
					TH_Consideration_10
				]
			},
			"gallery": {
				"poster": TH_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					TH_Gallery_1,
					TH_Gallery_2,
					TH_Gallery_3,
					TH_Gallery_4,
					TH_Gallery_5,
					TH_Gallery_6
				]
			}
		}
	},
	// GABBYS DOLLHOUSE
	{
		"id": 2,
		"layout": "fourth",
		"name": "Gabby's Dollhouse",
		"slug": "gabbys-dollhouse",
		"logo": GD_Logo,
		"poster": GD_Poster,
		"inner": {
			"hero": GD_Hero,
			"copyright": "DREAMWORKS GABBY’S DOLLHOUSE © "+currentYear+" DREAMWORKS ANIMATION LLC. ALL RIGHTS RESERVED.",
			"description": "Welcome to Gabby's Dollhouse, the preschool show with a surprise inside! Created and executive produced by Traci Paige Johnson (Blue's Clues, Daniel Tiger's Neighborhood) and Jennifer Twomey (Blue's Clues, Team Umizoomi), Gabby's Dollhouse is a mixed media series that unboxes a surprise before jumping into a fantastical animated world full of adorable cat characters that live inside Gabby’s dollhouse. Any adventure can unfold when we play in Gabby's Dollhouse!",
			"streaming": [
				{
					"platform": "Netflix",
					"logo": Netflix,
					"link": "https://www.netflix.com/title/81009946"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/_rPl35ZvmJU?autoplay=1",
					"poster": GD_Item1,
					"title": "Series Trailer",
					"description": "More dancing, wild adventures, and Cakey-bakey fun with purr-fect friends!"
				},
				{
					"video": "https://www.youtube.com/embed/XnmXXck4ZEU?autoplay=1",
					"poster": GD_Item2,
					"title": "Day at the Dollhouse Hotel",
					"description": "When Gabby unboxes a suitcase and a hotel brochure, it’s time to take a trip!"
				},
				{
					"video": "https://www.youtube.com/embed/C00YO_0Ayrg?autoplay=1",
					"poster": GD_Item3,
					"title": "Knights of the Kitty Kat Castle",
					"description": "Gabby, Pandy and CatRat must complete three acts of knighthood to prove they are worthy of becoming knights of the Kitty Cat Castle!"
				},
			],
			"gallery": {
				"poster": GD_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					GD_Gallery_1,
					GD_Gallery_2,
					GD_Gallery_3,
					GD_Gallery_4,
					GD_Gallery_5
				]
			}
		}
	},
	// FAST & FURIOUS: SPY RACERS
	{
		"id": 3,
		"layout": "first",
		"name": "Fast & Furious: Spy Racers South Pacific",
		"slug": "fast-furious-spy-racers-south-pacific",
		"logo": FF_Logo,
		"poster": FF_Poster,
		"inner": {
			"hero": FF_Hero,
			"copyright": "Fast & Furious and all related elements TM & © "+currentYear+" Universal City Studios LLC. TV Series © "+currentYear+" DreamWorks Animation LLC. All rights reserved.",
			"description": "Teenager Tony Toretto follows in the footsteps of his cousin Dom when he and his friends are recruited by a government agency to infiltrate an elite racing league serving as a front for a nefarious crime organization bent on world domination. Tim Hedrick (Voltron Legendary Defender) and Bret Haaland (All Hail King Julien) will serve as executive producers and showrunners. The series is also executive produced by Vin Diesel and Chris Morgan who also serve as producers on the live-action Fast & Furious franchise.",
			"streaming": [
				{
					"platform": "Netflix",
					"logo": Netflix,
					"link": "https://www.netflix.com/title/80225085"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/CFri0FO4nlg?autoplay=1",
					"poster": FF_Item1,
					"title": "Series Trailer",
					"description": "Get ready to make some waves as the crew finds themselves on the run through land, air, and sea in the South Pacific."
				},
				{
					"video": "https://www.youtube.com/embed/5BV4c7qmbNc?autoplay=1",
					"poster": FF_Item2,
					"title": "Ms. Nowhere and Palindrome",
					"description": "With tensions running high, will Ms. Nowhere and Palindrome be able to get past their differences and work together as a team?"
				},
				{
					"video": "https://www.youtube.com/embed/sFl2EaiIesw?autoplay=1",
					"poster": FF_Item3,
					"title": "Captain Cisco",
					"description": "The Spy Racers must defend themselves against their most daunting enemy yet: the sea!"
				}
			],
			"consideration": {
				"poster": FF_Consideration,
				"title": "Production Design by Christine\nBian, Walter\nKim, Sonny\nFisher, Ronaldo\nMei and Pace\nWilder",
				"description": "Christine\nBian, Walter\nKim, Sonny\nFisher, Ronaldo\nMei and Pace\nWilder created a stunning production design.",
				"btnText": "View Now",
				"images": [
					FF_Consideration_1,
					FF_Consideration_2,
					FF_Consideration_3,
					FF_Consideration_4,
					FF_Consideration_5,
					FF_Consideration_6,
					FF_Consideration_7,
					FF_Consideration_8,
					FF_Consideration_9,
					FF_Consideration_10
				]
			},
			"gallery": {
				"poster": FF_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					FF_Gallery_1,
					FF_Gallery_2,
					FF_Gallery_3,
					FF_Gallery_4,
					FF_Gallery_5,
					FF_Gallery_6,
					FF_Gallery_7,
					FF_Gallery_8,
					FF_Gallery_9,
					FF_Gallery_10,
					FF_Gallery_11,
					FF_Gallery_12
				]
			}
		}
	},
	// THE CROODS
	{
		"id": 4,
		"layout": "fourth",
		"name": "THE CROODS: FAMILY TREE",
		"slug": "the-croods-family-tree",
		"logo": CDS_Logo,
		"poster": CDS_Poster,
		"inner": {
			"hero": CDS_Hero,
			"copyright": "DREAMWORKS THE CROODS FAMILY TREE © "+currentYear+" DREAMWORKS ANIMATION LLC. ALL RIGHTS RESERVED.",
			"description": "Inspired by the blockbuster DreamWorks Animation film The Croods: A New Age, The Croods: Family Tree continues the ever-evolving story of the Croods and the Bettermans as they learn to live together on the most idyllic farm in prehistory. The journey from sparring rivals to unlikely friends is fraught with hilarious misadventures as the two families slowly overcome their differences to turn a tree house divided into a tree home united.",
			"streaming": [
				{
					"platform": "Peacock",
					"logo": Peacock,
					"link": "https://www.peacocktv.com/watch-online/tv/the-croods-family-tree/8267416623237381112"
				},
				{
					"platform": "Hulu",
					"logo": Hulu,
					"link": "https://www.hulu.com/series/the-croods-family-tree"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/KU6vq6b51cw?autoplay=1",
					"poster": CDS_Item1,
					"title": "Series Trailer",
					"description": "The future of family fun starts here!"
				},
				{
					"video": "https://www.youtube.com/embed/ABdTeVJw1fg?autoplay=1",
					"poster": CDS_Item2,
					"title": "The Bounceberries Taste Like Bounceberries",
					"description": "Determined to prove their worth on the Betterman farm, the Croods set out to harvest the seriously sticky bounceberries."
				},
				{
					"video": "https://www.youtube.com/embed/Ol56DVjDs3g?autoplay=1",
					"poster": CDS_Item3,
					"title": "GRR Mountain",
					"description": "Dawn and Eep are in for some real mountain mayhem."
				},
			],
			"gallery": {
				"poster": CDS_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					CDS_Gallery_1,
					CDS_Gallery_2,
					CDS_Gallery_3,
					CDS_Gallery_4,
					CDS_Gallery_5,
					CDS_Gallery_6,
					CDS_Gallery_7,
					CDS_Gallery_8
				]
			}
		}
	},
	// DRAGONS: THE NINE REALMS
	{
		"id": 5,
		"layout": "fourth",
		"name": "Dragons: The Nine Realms",
		"slug": "dragons-the-nine-realms",
		"logo": DNR_Logo,
		"poster": DNR_Poster,
		"inner": {
			"hero": DNR_Hero,
			"copyright": "DREAMWORKS DRAGONS: NINE REALMS © "+currentYear+" DREAMWORKS ANIMATION LLC. ALL RIGHTS RESERVED.",
			"description": "Set 1,300 years after the events of How To Train Your Dragon, dragons are now just a legend to the modern world. When a geological anomaly opens up an immense, miles-deep fissure in the Earth’s surface, scientists from all over the world gather at a new research facility to study the mysterious phenomenon. Soon a group of misfit kids, brought to the site by their parents, uncover the truth about dragons and where they’ve been hiding -- a secret they must keep to themselves to protect what they’ve discovered. From executive producer John Tellegen (Dragons: Race to the Edge),  Dragons: The Nine Realms soars onto hulu and Peacock December 23.",
			"streaming": [
				{
					"platform": "Peacock",
					"logo": Peacock,
					"link": "https://peacocktv.com"
				},
				{
					"platform": "Hulu",
					"logo": Hulu,
					"link": "https://hulu.com"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/0HpuSv6dwws?autoplay=1",
					"poster": DNR_Item1,
					"title": "The Future of Dragon is Here",
					"description": "Coming Dec 23 to Hulu and Peacock."
				},
				{
					"video": "https://www.youtube.com/embed/RC7NHVOzYDo?autoplay=1",
					"poster": DNR_Item2,
					"title": "Series Trailer",
					"description": "After 1300 years, the world has changed and a new legend begins."
				}
			],
			"gallery": {
				"poster": DNR_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					DNR_Gallery_1,
					DNR_Gallery_2,
					DNR_Gallery_3,
					DNR_Gallery_4,
					DNR_Gallery_5,
					DNR_Gallery_6,
					DNR_Gallery_7,
					DNR_Gallery_8,
					DNR_Gallery_9,
					DNR_Gallery_10,
					DNR_Gallery_11,
					DNR_Gallery_12,
					DNR_Gallery_13,
					DNR_Gallery_14,
					DNR_Gallery_15,
					DNR_Gallery_16,
					DNR_Gallery_17
				]
			}
		}
	},
	// MADAGASCAR: A LITTLE WILD
	{
		"id": 6,
		"layout": "first",
		"name": "MADAGASCAR: A LITTLE WILD",
		"slug": "madagascar-a-little-wild",
		"logo": MAD_Logo,
		"poster": MAD_Poster,
		"inner": {
			"hero": MAD_Hero,
			"copyright": "Dreamworks Madagascar © "+currentYear+" Dreamworks Animation LLC. All Rights Reserved.",
			"description": "Loveable foursome Alex the Lion, Marty the Zebra, Melman the Giraffe and Gloria the Hippo steal the show in Madagascar: A Little Wild, executive produced by Johanna Stein (Kung Fu Panda: The Paws of Destiny). Capturing the iconic personalities of each of the four dynamos, Madagascar: A Little Wild showcases the team as kids residing in their rescue habitat at the Central Park Zoo. They might be small, but like everybody who lands in New York City, these little guys have big dreams and Madagascar: A Little Wild will follow all of their adventures.",
			"streaming": [
				{
					"platform": "Peacock",
					"logo": Peacock,
					"link": "https://www.peacocktv.com/watch-online/tv/madagascar-a-little-wild/6494384629026654112"
				},
				{
					"platform": "Hulu",
					"logo": Hulu,
					"link": "https://www.hulu.com/series/madagascar-a-little-wild-7a11e023-5762-4980-bfce-7f337e4c28ef"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/bZb9OqaBUwI?autoplay=1",
					"poster": MAD_Item1,
					"title": "Series Trailer",
					"description": "They're little. They're Wild. They're ready to get a little wild!"
				},
				{
					"video": "https://www.youtube.com/embed/Gwy-uSm3_K0?autoplay=1",
					"poster": MAD_Item2,
					"title": "Be Proud",
					"description": "Meet Odee the Okapi! Although Odee may not look or feel just like the other animals at the habitat, it becomes clear to everyone that it doesn’t matter what you are – it only matters who you are!"
				},
				{
					"video": "https://www.youtube.com/embed/SgeX9XVJTQ0?autoplay=1",
					"poster": MAD_Item3,
					"title": "Meet Starlene",
					"description": "Meet Starlene, the little crab with some seriously big talent, voiced by Grammy winner Alanis Morrisette!"
				},
			],
			"consideration": {
				"poster": MAD_Bonus,
				"title": "Madagascar animated series welcomes a nonbinary character in Pride episode sneak peek",
				"link": "https://ew.com/tv/madagascar-a-little-wild-nonbinary-character-odee-ezra-menas-clip/",
				"btnText": "View Now"
			},
			"gallery": {
				"poster": MAD_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					MAD_Gallery_1,
					MAD_Gallery_2,
					MAD_Gallery_3,
					MAD_Gallery_4,
					MAD_Gallery_5
				]
			}
		}
	},
	// GO DOG GO
	{
		"id": 7,
		"layout": "second",
		"name": "Go, Dog. Go!",
		"slug": "go-dog-go",
		"logo": GDG_Logo,
		"poster": GDG_Poster,
		"inner": {
			"hero": GDG_Hero,
			"copyright": "GO, DOG. GO! TV SERIES © "+currentYear+" DHX-GO DOG GO PRODUCTIONS INC. ALL RIGHTS RESERVED.",
			"description": "Based on PD Eastman's beloved and classic children’s book, Go, Dog. Go! follows 6-year-old Tag Barker on her adventures in the city of Pawston, a fun-loving community of dogs on the go. Tag is a skilled mechanic and loves anything that goes. With her ingenuity and creativity, Tag can go as far as any plan will take her with her best friend Scooch Pooch by her side.",
			"streaming": [
				{
					"platform": "Netflix",
					"logo": Netflix,
					"link": "https://www.netflix.com/Title/81047300"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/26qItuggWz4?autoplay=1",
					"poster": GDG_Item1,
					"title": "Series Trailer",
					"description": "Join Tag Barker and her best friend, Scooch Pooch, as they chase adventure throughout the community of Pawston"
				},
				{
					"video": "https://www.youtube.com/embed/l-6nwtapoT4?autoplay=1",
					"poster": GDG_Item2,
					"title": "Party in the Tree",
					"description": "A series of traffic jams threatens to make Tag and Scooch late for the Party in the Tree!"
				},
				{
					"video": "https://www.youtube.com/embed/agQCBieUUfI?autoplay=1",
					"poster": GDG_Item3,
					"title": "A Motorcycle Jump for Friendship",
					"description": "Beans is nervous that Frank is starting to make a new best friend, so Beans enlists Tag to help him win Frank back!"
				},
			],
			"gallery": {
				"poster": GDG_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					GDG_Gallery_1,
					GDG_Gallery_2,
					GDG_Gallery_3
				]
			}
		}
	},
	// THE MIGHTY ONES
	{
		"id": 8,
		"layout": "first",
		"name": "THE MIGHTY ONES",
		"slug": "the-mighty-ones",
		"logo": TMO_Logo,
		"poster": TMO_Poster,
		"inner": {
			"hero": TMO_Hero,
			"copyright": "Dreamworks The Mighty Ones © "+currentYear+" Dreamworks Animation LLC. All Rights Reserved.",
			"description": "In every backyard a secret world exists filled with tiny creatures. The Mighty Ones follows the hilarious adventures of the smallest of them: a twig, a pebble, a leaf and a strawberry who call themselves “the Mighty Ones.” These best friends live in an unkempt backyard belonging to a trio of equally unkempt humans who they mistake for gods. Despite their diminutive stature, the Mighty Ones are determined to live large and have fun in their wild world.",
			"streaming": [
				{
					"platform": "Peacock",
					"logo": Peacock,
					"link": "https://www.peacocktv.com/watch-online/tv/the-mighty-ones/8501865675229905112"
				},
				{
					"platform": "Hulu",
					"logo": Hulu,
					"link": "https://www.hulu.com/series/the-mighty-ones-7b34470f-f28a-4740-8840-82a7355ce2ac"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/x_TsggciA_Y?autoplay=1",
					"poster": TMO_Item1,
					"title": "Series Trailer",
					"description": "Dreaming bigger, running wilder, and living larger…"
				},
				{
					"video": "https://www.youtube.com/embed/1rkmrrahHo4?autoplay=1",
					"poster": TMO_Item2,
					"title": "Fur Mountain",
					"description": "A search for Twig leads The Mighty Ones to the mysterious Fur Mountain."
				},
				{
					"video": "https://www.youtube.com/embed/AKQJHu02GTs?autoplay=1",
					"poster": TMO_Item3,
					"title": "Koko",
					"description": "The Mighty Ones are confused when Berry mistakes a predator for her new best friend."
				},
			],
			"consideration": {
				"poster": TMO_Consideration,
				"title": "Production Design by Jenny\nGase-Baker",
				"description": "Jenny\nGase-Baker created a stunning production design.",
				"btnText": "View Now",
				"images": [
					TMO_Consideration_1,
					TMO_Consideration_2,
					TMO_Consideration_3,
					TMO_Consideration_4,
					TMO_Consideration_5,
					TMO_Consideration_6,
					TMO_Consideration_7,
					TMO_Consideration_8,
					TMO_Consideration_9
				]
			},
			"gallery": {
				"poster": TMO_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					TMO_Gallery_1,
					TMO_Gallery_2,
					TMO_Gallery_3,
					TMO_Gallery_4,
					TMO_Gallery_5
				]
			}
		}
	},
	// ARCHIBALD'S NEXT BIG THING
	{
		"id": 9,
		"layout": "fourth",
		"name": "Archibald's Next Big Thing is Here",
		"slug": "archibalds-next-big-thing-is-here",
		"logo": NBT_Logo,
		"poster": NBT_Poster,
		"inner": {
			"hero": NBT_Hero,
			"copyright": "Dreamworks Archibald's Next Big Thing © "+currentYear+" Dreamworks Animation LLC. All Rights Reserved.",
			"description": "From the creative mind of Tony Hale, Archibald’s Next Big Thing is Here is the next chapter for Archibald Strutter, a chicken who “yes-and’s” his way through life. While his adventures don’t always go as planned, Archibald takes it one step at a time with the help of his three siblings, Sage, Finly, and Loy, and his trusty sidekick, Bea.",
			"streaming": [
				{
					"platform": "Peacock",
					"logo": Peacock,
					"link": "https://www.peacocktv.com/watch-online/tv/archibalds-next-big-thing-is-here/6954469721385809112"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/alVYLijR1lo?autoplay=1",
					"poster": NBT_Item1,
					"title": "Series Trailer",
					"description": "Our same little chicken is back for brand new and seriously egg-citing adventures!"
				},
				{
					"video": "https://www.youtube.com/embed/WmoxQt2R2Dg?autoplay=1",
					"poster": NBT_Item2,
					"title": "Earl the Astronaut",
					"description": "Archibald meets Earl, a nervous astronaut with a lot to learn and an exciting adventure ahead."
				},
				{
					"video": "https://www.youtube.com/embed/b2d26BnVyGM?autoplay=1",
					"poster": NBT_Item3,
					"title": "Who is the Real Archibald",
					"description": "When Archibald’s doppelganger threatens to become a permanent fixture in the Strutter House, Archibald must prove he is the real deal!"
				}
			],
			"gallery": {
				"poster": NBT_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					NBT_Gallery_1,
					NBT_Gallery_2,
					NBT_Gallery_3,
					NBT_Gallery_4,
					NBT_Gallery_5,
					NBT_Gallery_6
				]
			}
		}
	},
	// DOUG UNPLUGS
	{
		"id": 10,
		"layout": "fourth",
		"name": "DOUG UNPLUGS",
		"slug": "doug-unplugs",
		"logo": DU_Logo,
		"poster": DU_Poster,
		"inner": {
			"hero": DU_Hero,
			"copyright": "Dreamworks Doug Unplugs © "+currentYear+" Dreamworks Animation LLC. All Rights Reserved.",
			"description": "Based on the critically acclaimed children’s book by Dan Yaccarino, DreamWorks Doug Unplugs follows a curious six-year-old robot, Doug, as he ‘plugs in’ to learn new facts about the world every day. Sensing there’s more to life than just the facts, Doug journeys into the human world in search of experience. And to do that, Doug has to...unplug. With the help of his best friend, a human ball of energy, Emma, the two discover all the simple wonders of the world. Join Doug as he learns about the intersection of technology and humanity, and how they both keep us truly connected!",
			"streaming": [
				{
					"platform": "Apple TV",
					"logo": AppleTV,
					"link": "https://tv.apple.com/us/show/doug-unplugs/umc.cmc.3oxevpgaoqomu820s0e70ri75"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/AHnHSr7_V2Q?autoplay=1",
					"poster": DU_Item1,
					"title": "Series Trailer",
					"description": "Doug and Emma return with big adventures!"
				},
				{
					"video": "https://www.youtube.com/embed/qxLbEEBrmcM?autoplay=1",
					"poster": DU_Item2,
					"title": "Fall Has Arrived",
					"description": "When there’s a chill in the air, leaves on the ground, and the smell of pumpkin spiced muffins, it can only mean one thing — it’s fall time! Emma shows Doug and the rest of the bots how fun fall can be."
				},
				{
					"video": "https://www.youtube.com/embed/WhNuv4hs4Eo?autoplay=1",
					"poster": DU_Item3,
					"title": "What Is A Habitat?",
					"description": "When a little duck loses his way, Doug and Emma try to help him find his way back home."
				}
			],
			"gallery": {
				"poster": DU_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					DU_Gallery_1,
					DU_Gallery_2,
					DU_Gallery_3,
					DU_Gallery_4,
					DU_Gallery_5,
					DU_Gallery_6,
					DU_Gallery_7
				]
			}
		}
	},
	// DRAGONS RESCUE RIDERS
	{
		"id": 11,
		"layout": "fourth",
		"name": "Dragons Rescue Riders: Heroes of the Sky",
		"slug": "dragons-rescue-riders-heros-of-the-sky",
		"logo": DRR_Logo,
		"logo2": DRR_Logo2,
		"poster": DRR_Poster,
		"inner": {
			"hero": DRR_Hero,
			"copyright": "Dreamworks Dragons © "+currentYear+" Dreamworks Animation LLC. All Rights Reserved.",
			"description": "In a faraway corner of the viking and dragon world, Dragons Rescue Riders Heroes of the Sky is the next chapter following the adventures of viking twins Dak and Leyla, who were rescued and raised by dragons, growing up learning to speak their language. Along with young dragons Winger, Summer, Cutter and Burple, they defend and protect other dragons on exciting adventures around their home of Huttsgalor.",
			"streaming": [
				{
					"platform": "Peacock",
					"logo": Peacock,
					"link": "https://www.peacocktv.com"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/PieavGBCBTo?autoplay=1",
					"poster": DRR_Item1,
					"title": "Series Trailer",
					"description": "Heroes take flight and friendship soars in the newest chapter of Dragons Rescue Riders: Heroes of the Sky!"
				},
				{
					"video": "https://www.youtube.com/embed/3E6XiO4sK7s?autoplay=1",
					"poster": DRR_Item2,
					"title": "Octopus and Eel Escape",
					"description": "The Riders set out to find the Sunken City of Valantis—an ancient Viking city where dragons and people were friends— but when they find it, they realize they aren’t alone down there in the lost city!"
				}
			],
			"gallery": {
				"poster": DRR_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					DRR_Gallery_1,
					DRR_Gallery_2,
					DRR_Gallery_3,
					DRR_Gallery_4,
					DRR_Gallery_5
				]
			}
		}
	},
	// TROLLS: TROLLSTOPIA
	{
		"id": 12,
		"layout": "fourth",
		"name": "TROLLS: TROLLSTOPIA",
		"slug": "trolls-trollstopia",
		"logo": TROLL_Logo,
		"poster": TROLL_Poster,
		"inner": {
			"hero": TROLL_Hero,
			"copyright": "Dreamworks Trolls © "+currentYear+" Dreamworks Animation LLC. All Rights Reserved.",
			"description": "Inspired by the beloved DreamWorks Animation films, TrollsTopia is the next chapter in the hairraising adventures of the trolls. Now that Poppy knows there are other musical trolls scattered throughout the forest, she bottles up her endless positivity and invites delegates from every troll tribe in the forest to live together in harmony in a grand experiment she calls TrollsTopia!",
			"streaming": [
				{
					"platform": "Peacock",
					"logo": Peacock,
					"link": "https://www.peacocktv.com/watch-online/tv/trolls-trollstopia/6176499515272572112"
				},
				{
					"platform": "Hulu",
					"logo": Hulu,
					"link": "https://www.hulu.com/series/trolls-trollstopia-a5f2363f-ecc2-494e-9cf9-b896f6d7e574"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/VfORuNBO7o8?autoplay=1",
					"poster": TROLL_Item1,
					"title": "Series Trailer",
					"description": "More tricks! More Treats! More Tiny Diamond!"
				},
				{
					"video": "https://www.youtube.com/embed/DYq6ZFwb9wo?autoplay=1",
					"poster": TROLL_Item2,
					"title": "Tiny Diamond’s Imaginary Friend",
					"description": "Meet Shiny Diamond, the new invisible best friend of Tiny Diamond! But will Poppy be able to keep the fantasy alive and become best friends forever with Shiny?"
				},
				{
					"video": "https://www.youtube.com/embed/4_536PhxtAU?autoplay=1",
					"poster": TROLL_Item3,
					"title": "Scare Troll Fashion Show",
					"description": "When Mr. Dinkles starts to eat the Techno Trolls’ dance plants in the TrollsTopia Community Garden, will the trolls be able to stop him from becoming a plant pest?"
				}
			],
			"gallery": {
				"poster": TROLL_Gallery,
				"title": "Art Gallery",
				"btnText": "View Now",
				"images": [
					TROLL_Gallery_1,
					TROLL_Gallery_2,
					TROLL_Gallery_3,
					TROLL_Gallery_4,
					TROLL_Gallery_5
				]
			}
		}
	},
	// RHYME TIME TOWN (SERIES)
	{
		"id": 13,
		"layout": "fourth",
		"name": "Rhyme Time Town",
		"slug": "rhyme-time-town",
		"logo": RTT_Logo,
		"poster": RTT_Poster,
		"inner": {
			"hero": RTT_Hero,
			"copyright": "Dreamworks Rhyme Time Town © "+currentYear+" Dreamworks Animation LLC. All Rights Reserved.",
			"description": "All aboard to DreamWorks Rhyme Time Town, where Daisy the Puppy and Cole the Kitten are ready to guide young children through a colorful and adventurous world filled with nursery rhymes and imaginative play.",
			"streaming": [
				{
					"platform": "Netflix",
					"logo": Netflix,
					"link": "https://www.netflix.com/watch/80226787"
				}
			],
			"items": [
				{
					"video": "https://www.youtube.com/embed/Bke37Zpwh-A?autoplay=1",
					"poster": RTT_Item1,
					"title": "Series Trailer",
					"description": "Embark on a colorful journey with Daisy the puppy and Cole the kitten as they explore Rhyme Time Town!"
				}
			]
		}
	}
]
